module.exports = __webpack_public_path__ + "img/Silverman-Case-Study-600px.acadc400.jpeg";